const AUTH_DATA = 'authData';
const JWT_TOKEN = 'jwtToken';
const REFRESH_TOKEN = 'refreshToken';
const GATEWAY = 'gateway';

export { AUTH_DATA, JWT_TOKEN, REFRESH_TOKEN, GATEWAY };
